module.exports = __webpack_public_path__ + "img/img (10).6a0299ab.jpg";